<script>
    import ImagePlaceholder from '../image-placeholder/image-placeholder.vue';

    export default {
        components: {
            ImagePlaceholder
        }
    };
</script>

<style src="./motivation-info.css" />

<template>
    <div class="motivation-info">
      <div class="text-message">
        <h2>Why Modus Versus?</h2>
        Capacitance cascading integer reflective interface data development high bus cache dithering transponder.
      </div>
        <div class="all-windows">
                  <div class="front-window transformed-left">
                                    <div class="image-wrapper">
                                        <image-placeholder></image-placeholder>
                                  </div>
                              </div>
                  <div class="front-window transformed-right">
                                    <div class="image-wrapper">
                                        <image-placeholder></image-placeholder>
                                  </div>
                              </div>
            <div class="front-window">
                <div class="image-wrapper">
                    <image-placeholder></image-placeholder>
                </div>
            </div>
        </div>
    </div>
</template>


// WEBPACK FOOTER //
// src/components/motivation-info/motivation-info.vue?3ae1018f